import React from 'react'
import { cn } from '@/common/utils/utils'
import { InputError } from './InputError'
import { Label } from '@/common/ui/Label'

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string | React.ReactNode
    error?: string
    helperText?: string
    isVertical?: boolean
    prefixIcon?: React.ReactNode
    iconClassName?: string
    labelClassName?: string
}

export const LabelInput = React.forwardRef<HTMLInputElement, Props>(
    (
        {
            className,
            isVertical = true,
            required,
            id,
            label,
            error,
            helperText,
            prefixIcon,
            iconClassName,
            labelClassName,
            ...props
        }: Props,
        ref,
    ) => {
        const helperTextId = id && helperText ? `${id}-helper-text` : undefined
        const describedBy = [props['aria-describedby'], !error && helperTextId].filter(Boolean).join(' ') || undefined

        const input = (
            <input
                ref={ref}
                id={id}
                required={required}
                className={cn(
                    'w-full rounded-full border border-gray-300 py-2 px-4 focus:outline-none focus:border-[#16a34a] focus:ring-1 focus:ring-[#16a34a]',
                    className,
                    prefixIcon && 'pl-7',
                )}
                {...props}
                aria-describedby={describedBy}
            />
        )
        return (
            <div className={`flex ${isVertical ? 'flex-col' : 'flex-row justify-between items-center'} w-full`}>
                {label && (
                    <Label className={cn('text-sm', labelClassName)} htmlFor={id}>
                        {label}
                    </Label>
                )}
                {prefixIcon ? (
                    <div className={cn('relative w-1/2', iconClassName)}>
                        <div className="pointer-events-none absolute inset-y-0 -left-7 flex items-center pl-3">
                            {prefixIcon}
                        </div>
                        {input}
                    </div>
                ) : (
                    input
                )}
                <InputError message={error} />
                {!error && helperText && (
                    <p id={helperTextId} className="text-muted-foreground text-sm mt-1">
                        {helperText}
                    </p>
                )}
            </div>
        )
    },
)
